import { render } from "./PopupAlert.vue?vue&type=template&id=0c4ac13b"
import script from "./PopupAlert.vue?vue&type=script&lang=js"
export * from "./PopupAlert.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__